exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinner{display:initial}.loading_bar{display:block;text-align:center;margin:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/common/Loading/Loading.less
// module id = 1623
// module chunks = 0